export default "__VITE_ASSET__C4nb4WZK__"